module.exports = __webpack_public_path__ + "img/small-4.4e90a3a6.webp";